import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAdjustRule, getAdjustRuleCinema } from '../../api/index';
import { isEmpty } from '@/utils';
export default {
  name: 'adjustRule',
  props: {
    module: String,
    customerData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      noData: false,
      movieInfo: {},
      showDialog: false,
      dialogForm: {
        page: 1,
        pagesize: 5,
        standard_id: '',
        cinema_name: ''
      },
      cinemaList: [],
      totalCount: 0,
      isOverflow: []
    };
  },
  methods: {
    toggleText: function toggleText(item) {
      this.$set(item, 'isExpanded', !item.isExpanded);
    },
    closeDialog: function closeDialog(done) {
      this.$refs.dialogForm.resetFields();
      done();
    },
    onChange: function onChange(val) {
      this.dialogForm.page = val;
      this.getDialogCinema();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.dialogForm.pagesize = val;
      this.getDialogCinema();
    },
    searchData: function searchData() {
      this.dialogForm.page = 1;
      this.getDialogCinema();
    },
    getDialogCinema: function getDialogCinema() {
      var _this = this;
      return new Promise(function (resolve) {
        var uid = _this.customerData.uid;
        getAdjustRuleCinema(_this.module, _objectSpread(_objectSpread({}, _this.dialogForm), {}, {
          uid: uid
        })).then(function (res) {
          _this.cinemaList = res.data.data.data;
          _this.totalCount = res.data.data.totalCount;
          resolve();
        });
      });
    },
    openRangeDialog: function openRangeDialog(data) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var rule_type, rule_id;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              rule_type = data.rule_type, rule_id = data.rule_id;
              if (!['2', '4'].includes(rule_type + '')) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this2.dialogForm = _objectSpread(_objectSpread({}, _this2.dialogForm), {}, {
                rule_id: rule_id,
                page: 1
              });
              _context.n = 2;
              return _this2.getDialogCinema();
            case 2:
              _this2.showDialog = true;
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getCycleDate: function getCycleDate(data) {
      var _data$cycle_data = data.cycle_data,
        cycle_data = _data$cycle_data === void 0 ? {} : _data$cycle_data;
      var _cycle_data$cycle_nam = cycle_data.cycle_name,
        cycle_name = _cycle_data$cycle_nam === void 0 ? [] : _cycle_data$cycle_nam,
        _cycle_data$cycle_tim = cycle_data.cycle_time,
        cycle_time = _cycle_data$cycle_tim === void 0 ? [] : _cycle_data$cycle_tim;
      var arr = [cycle_name, cycle_time].map(function (i) {
        return i.join('、');
      }).filter(Boolean).join('，');
      return arr || '未设置';
    },
    getRule: function getRule(data) {
      var _data$adjust_type = data.adjust_type,
        adjust_type = _data$adjust_type === void 0 ? [] : _data$adjust_type,
        by_ratio_adjust = data.by_ratio_adjust,
        by_money_adjust = data.by_money_adjust;
      var hasMarketPrice = adjust_type.includes('1');
      var hasAdjustmentAmount = adjust_type.includes('2');
      var str = '';
      if (hasMarketPrice && hasAdjustmentAmount) {
        str = "\u4EE5\u5E02\u573A\u4EF7\u505A\u4E3A\u8C03\u4EF7\u57FA\u6570\uFF0C\u6309".concat(by_ratio_adjust, "%\u6D6E\u52A8\u540E\u589E\u52A0").concat(by_money_adjust);
      } else if (hasMarketPrice) {
        str = "\u4EE5\u5E02\u573A\u4EF7\u505A\u4E3A\u8C03\u4EF7\u57FA\u6570\uFF0C\u6309".concat(by_ratio_adjust, "%\u6D6E\u52A8");
      } else if (hasAdjustmentAmount) {
        str = "\u4EE5\u5E02\u573A\u4EF7\u505A\u4E3A\u8C03\u4EF7\u57FA\u6570\uFF0C\u589E\u52A0".concat(by_money_adjust);
      }
      return str;
    },
    loadData: function loadData() {
      var _this3 = this;
      var _this$customerData = this.customerData,
        uid = _this$customerData.uid,
        account_id = _this$customerData.account_id;
      getAdjustRule(this.module, {
        uid: uid,
        account_id: account_id
      }).then(function (res) {
        for (var key in res.data) {
          if (isEmpty(res.data[key]['rules'])) {
            _this3.noData = true;
            return;
          }
        }
        _this3.movieInfo = res.data.movie;
        _this3.$nextTick(function () {
          _this3.isOverflow = _this3.$refs.timeContent.map(function (text) {
            return text.scrollHeight > text.clientHeight;
          });
        });
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};